/**
 * Comunicaciones API
 * Comunicaciones API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ComunicacionesCategoriaDTO } from "./comunicacionesCategoriaDTO";

export interface ComunicacionesSubcategoriaDTO {
    id?: number;
    descripcion?: string;
    descripcionCorta?: string;
    categoria?: ComunicacionesCategoriaDTO;
    codigo?: string;
}
